import RichText from './RichText'

export { default as RichText } from './RichText'
export { default as RichTextLite } from './RichTextLite'
export {
  CenterDecorator,
  ColorDecorator,
  LeftDecorator,
  LinkDecorator,
  RightDecorator,
  StyledOlList,
  StyledStrong,
  StyledUlList,
  TextStyleBase,
  TextStyleBlockquote,
  TextStyleH1,
  TextStyleH2,
  TextStyleH3,
  TextStyleH4,
  TextStyleH5,
  TextStyleH6,
  TextStyleLarge,
  TextStyleMicro,
  TextStyleNano,
  TextStyleSmall
} from './shared'

export default RichText

/**
 * DEPRECATED: Use RichText component instead
 */
export const CustomPortableText = RichText